import swal from 'sweetalert2'
import api from '../../models/supplier'
import supplierEditModal from '../../components/modal/supplier_edit_modal'
import supplierAddModal from '../../components/modal/supplier_add_modal'

export default {
  name: 'supplier',
  components: {
    supplierAddModal,
    supplierEditModal,
  },
  data() {
    return {
      search_text: '',
      is_active: 1,
      per_page: 100,
      active_page: 1,
      isLoad: false,
      result_data: {
        pagination: [],
        count: 0,
      },
      str_data: '',
      modal_type: 0,
      modal_data: {
        supplier_id: 0,
        code: '',
        name: '',
        fullname: '',
        plantcode: '',
        address: '',
        tel: '',
        fax: '',
        email: '',
        tax: '',
        note: '',
        active: 1,
      },
    }
  },
  methods: {
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage(value) {
      this.active_page = value
      this.search()
    },
    ExportData() {
      $('.preloader').fadeIn()
      var obj = {
        search: this.search_text,
        active: this.is_active,
      }
      this.header.params = obj
      api.exportSupplier(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.str_data = JSON.stringify(result.data.export_data)
            setTimeout(() => {
              this.$refs.Exportfile.submit()
              $('.preloader').fadeOut()
            }, 1000)
          } else {
            this.alert_msg('warning', 'Export Supplier', result.message)
            $('.preloader').fadeOut()
          }
          this.isLoad = false
        },
        (error) => {
          $('.preloader').fadeOut()
          this.alert_msg('error', 'Export Supplier', error.message)
          this.isLoad = false
        }
      )
    },
    search() {
      this.isLoad = true
      var obj = {
        search: this.search_text,
        active: this.is_active,
        page: this.active_page,
        limit: this.per_page,
      }
      this.result_data.pagination = []
      this.result_data.count = 0
      this.header.params = obj
      api.listSupplier(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.result_data = result.data
          } else {
            this.alert_msg('warning', 'Supplier', result.message)
          }
          this.isLoad = false
        },
        (error) => {
          this.alert_msg('error', 'Supplier', error.message)
          this.isLoad = false
        }
      )
    },
    addSupplier() {
      this.modal_type = 0
      this.modal_data = {
        supplier_id: 0,
        code: '',
        name: '',
        fullname: '',
        plantcode: '',
        address: '',
        tel: '',
        fax: '',
        email: '',
        tax: '',
        note: '',
      }
      this.ModalBoots('SupplierModal').show()
    },
    editSupplier(obj) {
      this.modal_type = 1
      this.modal_data = obj
      this.ModalBoots('SupplierModal').show()
    },
    deleteSupplier(obj) {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm delete supplier : ' + obj.name,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel',
        })
        .then((result) => {
          if (result.value) {
            api.deleteSupplier(
              this.$store.state.URLHost,
              obj.id,
              this.header,
              (result) => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.search()
              },
              (error) => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.search()
              }
            )
          }
        })
    },
  },
  created() {
    this.checkOAuth()
  },
  mounted() {
    setTimeout(() => {
      if (sessionStorage.token) {
        this.activePage(1)
      } else {
        setTimeout(() => {
          this.activePage(1)
        }, 1000)
      }
    }, 1000)
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/suppliermanage.js